module.exports = __webpack_public_path__ + "img/unpin.5c41adfc.svg";